import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Products from '../pages/Products';
import banner1 from '../assets/banner2.png';
import banner2 from '../assets/banner1.png';
import banner3 from '../assets/banner3.png';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentBanner, setCurrentBanner] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const navigate = useNavigate();

  // Banner data
  const banners = [
    {
      id: 1,
      image: banner3,
      title: 'Premium Wheat Flour Collection',
      description:
        'Enjoy 20% off our artisanal wheat flour selection this week only!',
      cta: 'Shop Now',
    },
    {
      id: 2,
      image: banner2,
      title: 'Organic Flour Revolution',
      description:
        'Discover our new certified organic flours for health-conscious cooking',
      cta: 'Explore',
    },
    {
      id: 3,
      image: banner1,
      title: 'Crafted for Excellence',
      description:
        'Meticulously sourced and milled to meet the highest quality standards',
      cta: 'Learn More',
    },
  ];

  // Auto banner transition
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 5000);

    // Animation trigger
    setIsVisible(true);

    return () => clearInterval(interval);
  }, [banners.length]);

  // Handle search input
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Animation variants
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <div className='bg-gradient-to-b from-white to-gray-50 min-h-screen mt-16'>
      {/* Hero Banner Slider */}
      <section className='pt-6 pb-10 px-4 mt-[100px] relative overflow-hidden'>
        <div className='container mx-auto'>
          <div className='relative h-[19.6rem] sm:h-[23.8rem] md:h-[28rem] lg:h-[32.2rem] xl:h-[36.4rem] rounded-2xl overflow-hidden shadow-xl'>
            <AnimatePresence>
              {banners?.map(
                (banner, index) =>
                  currentBanner === index && (
                    <motion.div
                      key={banner.id}
                      className='absolute inset-0'
                      initial={{ opacity: 0, scale: 1.1 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.7 }}
                    >
                      {/* <div
                        className='absolute inset-0 bg-gradient-to-r z-10'
                        style={{
                          background:
                            'linear-gradient(to right, #C4A484CC, transparent)',
                        }}
                      ></div> */}

                      <img
                        src={banner.image}
                        alt={banner.title}
                        className='w-full h-full object-contain object-center bg-black'
                      />
                      <motion.div
                        className='absolute bottom-0 left-0 p-6 md:p-8 z-10 text-white max-w-md'
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                      >
                        {/* <h2 className='text-xl sm:text-2xl md:text-3xl font-bold mb-2 md:mb-3'>
                          {banner.title}
                        </h2>
                        <p className='text-sm md:text-base mb-4 md:mb-6 text-white/90 max-w-sm'>
                          {banner.description}
                        </p> */}
                        <motion.button
                          onClick={() => navigate('/products')}
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          className='px-5 py-2 bg-white text-blue-600 font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300'
                        >
                          {banner.cta}
                        </motion.button>
                      </motion.div>
                    </motion.div>
                  )
              )}
            </AnimatePresence>

            {/* Navigation Controls */}
            <div className='absolute bottom-4 right-6 flex space-x-3 z-20'>
              {banners.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentBanner(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                    currentBanner === index
                      ? 'bg-white w-6'
                      : 'bg-white/50'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {/* Arrow Controls */}
            <button
              onClick={() =>
                setCurrentBanner(
                  (prev) =>
                    (prev - 1 + banners.length) % banners.length
                )
              }
              className='absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M15 19l-7-7 7-7'
                />
              </svg>
            </button>

            <button
              onClick={() =>
                setCurrentBanner(
                  (prev) => (prev + 1) % banners.length
                )
              }
              className='absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M9 5l7 7-7 7'
                />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Featured Benefits */}
      <section className='py-8 px-4'>
        <div className='container mx-auto'>
          <motion.div
            className='grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6'
            initial='hidden'
            animate={isVisible ? 'visible' : 'hidden'}
            variants={{
              visible: { transition: { staggerChildren: 0.1 } },
            }}
          >
            <motion.div
              variants={fadeIn}
              className='bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-shadow border border-gray-100'
            >
              <div className='w-12 h-12 bg-blue-100 rounded-lg mb-3 flex items-center justify-center text-blue-600'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='h-6 w-6'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
              </div>
              <h3 className='font-semibold text-gray-800'>
                Premium Quality
              </h3>
              <p className='text-sm text-gray-600 mt-1'>
                100% natural, no additives
              </p>
            </motion.div>

            <motion.div
              variants={fadeIn}
              className='bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-shadow border border-gray-100'
            >
              <div className='w-12 h-12 bg-green-100 rounded-lg mb-3 flex items-center justify-center text-green-600'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='h-6 w-6'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3'
                  />
                </svg>
              </div>
              <h3 className='font-semibold text-gray-800'>
                Fresh Milling
              </h3>
              <p className='text-sm text-gray-600 mt-1'>
                Stone-ground flour variants
              </p>
            </motion.div>

            <motion.div
              variants={fadeIn}
              className='bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-shadow border border-gray-100'
            >
              <div className='w-12 h-12 bg-amber-100 rounded-lg mb-3 flex items-center justify-center text-amber-600'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='h-6 w-6'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
              </div>
              <h3 className='font-semibold text-gray-800'>
                Fast Delivery
              </h3>
              <p className='text-sm text-gray-600 mt-1'>
                Within 24 hours
              </p>
            </motion.div>

            <motion.div
              variants={fadeIn}
              className='bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-shadow border border-gray-100'
            >
              <div className='w-12 h-12 bg-purple-100 rounded-lg mb-3 flex items-center justify-center text-purple-600'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='h-6 w-6'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
                  />
                </svg>
              </div>
              <h3 className='font-semibold text-gray-800'>
                Cash on Delivery
              </h3>
              <p className='text-sm text-gray-600 mt-1'>
                Safe & Fast
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Product Showcase */}
      <section className='py-10 px-4'>
        <div className='container mx-auto'>
          <div className='flex items-center justify-between mb-8'>
            <div>
              <h2 className='text-2xl md:text-3xl font-bold text-gray-800 flex items-center'>
                <span className='w-8 h-1 bg-blue-600 rounded-full mr-3 hidden sm:block'></span>
                Our Premium Collection
              </h2>
              <p className='text-gray-600 mt-1 ml-0 sm:ml-11'>
                Discover our finest flour selections
              </p>
            </div>
            <Link
              to='/products'
              className='px-4 py-2 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition-colors duration-300 flex items-center gap-1 text-sm font-medium'
            >
              View All
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-5 w-5'
                viewBox='0 0 20 20'
                fill='currentColor'
              >
                <path
                  fillRule='evenodd'
                  d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z'
                  clipRule='evenodd'
                />
              </svg>
            </Link>
          </div>

          <div className='bg-white rounded-2xl p-6 shadow-lg'>
            <Products />
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className='py-12 px-4 bg-gradient-to-b from-gray-50 to-gray-100 rounded-t-3xl relative overflow-hidden'>
        <div className='absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-blue-500'></div>
        <div className='container mx-auto relative z-10'>
          <div className='text-center mb-10'>
            <h2 className='text-2xl md:text-3xl font-bold mb-3 text-gray-800'>
              Customer Experiences
            </h2>
            <p className='text-gray-600 max-w-xl mx-auto'>
              Hear what our satisfied customers have to say about our
              premium flour products
            </p>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
            <motion.div
              className='bg-white p-6 rounded-xl shadow-md border border-gray-100'
              whileHover={{
                y: -8,
                boxShadow: '0 10px 40px -15px rgba(0,0,0,0.1)',
              }}
              transition={{ duration: 0.3 }}
            >
              <div className='flex items-center mb-4'>
                <div className='w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mr-4 text-xl'>
                  <span className='text-blue-600 font-bold'>SJ</span>
                </div>
                <div>
                  <div className='font-semibold text-gray-800'>
                    Pravin Shinde
                  </div>
                  <div className='text-yellow-400 flex'>★★★★★</div>
                </div>
              </div>
              <p className='text-gray-700'>
                "I've tried many different brands of wheat flour, but
                this one is exceptional. My chapatis turn out so soft
                and delicious every time. Highly recommend!"
              </p>
              <div className='mt-4 text-sm text-gray-500'>
                Pune, India
              </div>
            </motion.div>

            <motion.div
              className='bg-white p-6 rounded-xl shadow-md border border-gray-100'
              whileHover={{
                y: -8,
                boxShadow: '0 10px 40px -15px rgba(0,0,0,0.1)',
              }}
              transition={{ duration: 0.3 }}
            >
              <div className='flex items-center mb-4'>
                <div className='w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mr-4 text-xl'>
                  <span className='text-blue-600 font-bold'>MT</span>
                </div>
                <div>
                  <div className='font-semibold text-gray-800'>
                    Shubham Kale
                  </div>
                  <div className='text-yellow-400 flex'>★★★★★</div>
                </div>
              </div>
              <p className='text-gray-700'>
                "The jowar flour has become a staple in my kitchen. As
                someone who follows a gluten-free diet, finding
                high-quality alternatives is important, and this
                exceeds my expectations."
              </p>
              <div className='mt-4 text-sm text-gray-500'>
                Pune, India
              </div>
            </motion.div>

            <motion.div
              className='bg-white p-6 rounded-xl shadow-md border border-gray-100'
              whileHover={{
                y: -8,
                boxShadow: '0 10px 40px -15px rgba(0,0,0,0.1)',
              }}
              transition={{ duration: 0.3 }}
            >
              <div className='flex items-center mb-4'>
                <div className='w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mr-4 text-xl'>
                  <span className='text-blue-600 font-bold'>RP</span>
                </div>
                <div>
                  <div className='font-semibold text-gray-800'>
                    Amol Patil
                  </div>
                  <div className='text-yellow-400 flex'>★★★★★</div>
                </div>
              </div>
              <p className='text-gray-700'>
                "The organic ragi flour is fantastic! It's incredibly
                fresh and makes wonderful rotis. The sustainable
                packaging is also a huge plus for me. Will definitely
                be ordering again."
              </p>
              <div className='mt-4 text-sm text-gray-500'>
                Restaurant Owner, Pune
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Newsletter Subscription */}
      {/* <section className='py-10 px-4 bg-blue-600 text-white'>
        <div className='container mx-auto'>
          <div className='max-w-3xl mx-auto text-center'>
            <h3 className='text-2xl font-bold mb-3'>Stay Updated</h3>
            <p className='mb-6 text-blue-100'>
              Subscribe to our newsletter for exclusive offers and
              baking tips
            </p>

            <form className='flex flex-col sm:flex-row gap-2 justify-center'>
              <input
                type='email'
                placeholder='Your email address'
                className='px-4 py-3 rounded-lg text-gray-800 flex-grow max-w-sm focus:outline-none focus:ring-2 focus:ring-yellow-400 transition-all duration-300'
              />
              <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                className='px-6 py-3 bg-yellow-500 text-blue-900 font-medium rounded-lg hover:bg-yellow-400 transition-colors duration-300'
              >
                Subscribe
              </motion.button>
            </form>

            <p className='text-xs mt-4 text-blue-200'>
              We respect your privacy and will never share your
              information
            </p>
          </div>
        </div>
      </section> */}

      {/* Bottom App Bar for Mobile */}
      <div className='md:hidden fixed bottom-0 left-0 right-0 bg-white shadow-lg z-20'>
        <div className='flex justify-around p-3'>
          <Link
            to='/'
            className='flex flex-col items-center text-blue-600'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
              />
            </svg>
            <span className='text-xs font-medium'>Home</span>
          </Link>
          <Link
            to='/products'
            className='flex flex-col items-center text-gray-500'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z'
              />
            </svg>
            <span className='text-xs font-medium'>Products</span>
          </Link>
          <Link
            to='/cart'
            className='flex flex-col items-center text-gray-500'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z'
              />
            </svg>
            <span className='text-xs font-medium'>Cart</span>
          </Link>
          <Link
            to='/profile'
            className='flex flex-col items-center text-gray-500'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
              />
            </svg>
            <span className='text-xs font-medium'>Profile</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
